import React, { FC } from 'react';
import { Button_v2 as Button, Typography, TypographyVariantsEnum } from '@mindly/ui-components';

type NeedOnboardingFeatureProps = {
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  onClick?: () => void;
};

const NeedOnboardingFeature: FC<NeedOnboardingFeatureProps> = ({ title, subtitle, buttonLabel, onClick }) => {
  return (
    <div className={'flex flex-col items-center gap-2'}>
      <Typography variant={TypographyVariantsEnum.Title24Semi} align={'center'}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant={TypographyVariantsEnum.Text14Regular} opacity={50} align={'center'}>
          {subtitle}
        </Typography>
      )}
      {buttonLabel && (
        <Button className={'!mt-3'} disabled={!onClick} isLoading={!onClick} onClick={onClick}>
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default NeedOnboardingFeature;
